import { render, staticRenderFns } from "./TotalInboundConfirmCell.vue?vue&type=template&id=4fb31ac1&"
import script from "./TotalInboundConfirmCell.vue?vue&type=script&lang=js&"
export * from "./TotalInboundConfirmCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports